import {
  CustomerSubmitForm,
  IdentityPayload,
  CustomerPayload,
} from "models/customer";
import axiosClient from "./axiosClient";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";

const customersApi = {
  getCustomersList(data: CustomerPayload): Promise<ApiResponse> {
    const params = new URLSearchParams();

    if (data.limit) params.append("limit", data.limit.toString());
    if (data.page) params.append("page", data.page.toString());
    if (data.search) params.append("search", data.search);
    if (data.sortName) params.append("sortField", data.sortName);
    if (data.sortType) params.append("sortType", data.sortType);

    const url = `/customer/getAllCustomer?${params.toString()}`;
    return axiosClient.get(url);
  },

  addCustomer(data: CustomerSubmitForm): Promise<ApiResponse> {
    const url = `/customer/addCustomer`;
    return axiosClient.post(url, data);
  },

  updateCustomer(data: CustomerSubmitForm): Promise<ApiResponse> {
    const url = `/customer/updateCustomer`;
    return axiosClient.put(url, data);
  },

  addUpdateCustomer(data: CustomerSubmitForm): Promise<ApiResponse> {
    const url = `/customer/addOrUpdateCustomer`;
    return axiosClient.post(url, data);
  },

  deleteCustomer(data: RemovePayload): Promise<ApiResponse> {
    const url = `/customer/removeCustomer?id=${data._id}`;
    return axiosClient.delete(url);
  },

  getIdentityTypes(data: IdentityPayload): Promise<ApiResponse> {
    const url = `/customer/getIdentityListByCountryRegion?countryRegion=${data}`;
    return axiosClient.get(url);
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  getfrontIdImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getbackIdImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default customersApi;
